
import { computed, defineComponent, ref, PropType } from 'vue'
import { AccordionVariantsEnum, AccordionVariantsArray, AccordionVariantsMap } from './BAccordion.types'

export default defineComponent({
  name: 'BAccordion',
  props: {
    title: {
      type: String,
      required: false,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String as PropType<AccordionVariantsEnum>,
      required: false,
      default: AccordionVariantsEnum.PRIMARY,
      validator: (prop: AccordionVariantsEnum) => AccordionVariantsArray.includes(prop)
    },
  },
  setup(props, { emit }) {
    const classes = computed(() => AccordionVariantsMap[props.variant])
    const isAccordionOpen = ref(props.isOpen)
    const contentAccordion = ref<null | HTMLElement>(null)
    const openClasses = computed(() => contentAccordion.value ? `max-height: ${contentAccordion.value.scrollHeight}px` : 'hidden')

    function click() {
      isAccordionOpen.value = !isAccordionOpen.value
      emit('open', isAccordionOpen.value)
    }
    return {
      isAccordionOpen,
      click,
      classes,
      contentAccordion,
      openClasses,
    }
  }
})
